import { Injectable } from '@angular/core';
import { map, merge, Observable, of, partition, Subject, tap } from 'rxjs';
import { QuoteData } from './quote-data';

@Injectable()
export class TransportService {
  calculated$: Observable<boolean>;
  private calculated = new Subject<boolean>();

  constructor() {
    this.calculated$ = this.calculated.asObservable();
  }

  calculate(quoteData: QuoteData): Observable<QuoteData> {
    const [transport, notransport] = partition(
      of(quoteData),
      (qd: QuoteData) => qd.GeneralData.CostTransport
    );

    return merge(
      transport.pipe(
        tap(() => this.calculated.next(false)),
        map((newQd: QuoteData) => {
          this.calculateTransport(newQd);
          this.calculated.next(true);
          return newQd;
        })
      ),
      notransport
    );
  }

  private calculateTransport(quoteData: QuoteData): void {
    quoteData.TransportData.TransportTotal =
      quoteData.TransportData.TransportLorries *
      (quoteData.TransportData.AreaBandCost +
        quoteData.TransportData.LoadLorryCost);
  }
}
